<template>
  <footer class="nf">
    <div class="nf__accent" aria-hidden="true"></div>

    <div class="nf__container">
      <div class="nf__grid">
        <div class="nf__col nf__col--brand">
          <router-link to="/" class="nf__logo" aria-label="Assuraf">
            <img src="../assets/img/assuraf_white.png" alt="Assuraf" />
          </router-link>
          <p class="nf__tagline">{{ $t('home_page.Descriptif_message[0]') }}</p>

          <ul class="nf__contact">
            <li>
              <i class="fas fa-map-marker-alt"></i>
              <span>{{ $t('footer.adresse') }}</span>
            </li>
            <li>
              <i class="fas fa-envelope"></i>
              <a href="mailto:contact@assuraf.com">{{ $t('footer.mail') }}</a>
            </li>
            <li>
              <i class="fas fa-phone"></i>
              <a href="tel:+221761416464">{{ $t('footer.telephone') }}</a>
            </li>
            <li>
              <i class="fab fa-whatsapp"></i>
              <a href="https://wa.me/221761416464?text=Hello%20Assur%27Web" target="_blank" rel="noopener noreferrer">
                {{ $t('footer.whatsapp') }}
              </a>
            </li>
          </ul>
        </div>

        <div class="nf__col">
          <h3 class="nf__title">{{ $t('footer.souscription_title') }}</h3>
          <ul class="nf__links">
            <li><router-link to="/devis/auto">{{ $t('footer.souscription_content_list[0]') }}</router-link></li>
            <li><router-link to="/devis/habitation">{{ $t('footer.souscription_content_list[1]') }}</router-link></li>
            <li><router-link to="/devis/voyage">{{ $t('footer.souscription_content_list[2]') }}</router-link></li>
            <li><router-link to="/devis/sante">{{ $t('footer.souscription_content_list[3]') }}</router-link></li>
            <li><router-link to="/devis/vie">{{ $t('footer.souscription_content_list[4]') }}</router-link></li>
            <li><router-link to="/plus">{{ $t('footer.souscription_content_list[5]') }}</router-link></li>
            <li class="nf__sep">{{ $t('home_page.entreprise_label') }}</li>
            <li><router-link to="/flotte/entreprise">{{ $t('menu.Devis[7]') }}</router-link></li>
            <li><router-link to="/devis/mrp">Devis MRP</router-link></li>
            <li><router-link to="/devis/trc">Devis TRC</router-link></li>
            <li><router-link to="/rcscolaire">{{ $t('menu.Devis[8]') }}</router-link></li>
          </ul>
        </div>

        <div class="nf__col">
          <h3 class="nf__title">{{ $t('footer.assuraf_title') }}</h3>
          <ul class="nf__links">
            <li><a href="/apropos#histoire">{{ $t('footer.assuraf_content_list[0]') }}</a></li>
            <li><a href="javascript:void(0)" @click="RedirectionEspaceAssure">{{ $t('footer.assuraf_content_list[1]') }}</a></li>
            <li><router-link to="/info/legale">{{ $t('footer.assuraf_content_list[2]') }}</router-link></li>
            <li><router-link to="/condition/generale">{{ $t('footer.assuraf_content_list[3]') }}</router-link></li>
            <li><a href="/apropos#faq">{{ $t('footer.assuraf_content_list[4]') }}</a></li>
            <li><a href="https://developer.assuraf.com/" target="_blank" rel="noopener noreferrer">{{ $t('footer.assuraf_content_list[5]') }}</a></li>
            <li><a href="https://assuraf.com/plateforme/demo" target="_blank" rel="noopener noreferrer">{{ $t('footer.assuraf_content_list[6]') }}</a></li>
            <li><a href="/cv">{{ $t('footer.assuraf_content_list[7]') }}</a></li>
            <li><a href="https://assur.care" target="_blank" rel="noopener noreferrer">{{ $t('footer.assuraf_content_list[8]') }}</a></li>
            <li><router-link to="/pro">Assuraf Pro Online</router-link></li>
            <li><router-link to="/lead">Assur'Lead</router-link></li>
            <li><a href="javascript:void(0)" @click="goToSinistre">{{ $t('menu.sinistre_label') }}</a></li>
          </ul>
        </div>

        <div class="nf__col">
          <h3 class="nf__title">{{ $t('footer.download_app_label') }}</h3>
          <div class="nf__stores">
            <a href="https://play.google.com/store/apps/details?id=com.afdecoding.assurafmobile" target="_blank" rel="noopener noreferrer">
              <img src="../assets/img/logo_playStore.png" alt="Play Store" loading="lazy" />
            </a>
            <a href="https://apps.apple.com/sn/app/assuraf/id1641569465?l=fr" target="_blank" rel="noopener noreferrer">
              <img src="../assets/img/logo-appStore.png" alt="App Store" loading="lazy" />
            </a>
          </div>

          <h3 class="nf__title nf__title--social">Réseaux sociaux</h3>
          <div class="nf__social">
            <a href="https://www.linkedin.com/company/assuraf/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" title="LinkedIn">
              <i class="fab fa-linkedin-in"></i>
            </a>
            <a href="https://twitter.com/assuraf_tech" target="_blank" rel="noopener noreferrer" aria-label="Twitter" title="Twitter">
              <i class="fab fa-twitter"></i>
            </a>
            <a href="https://www.facebook.com/assuraf/" target="_blank" rel="noopener noreferrer" aria-label="Facebook" title="Facebook">
              <i class="fab fa-facebook-f"></i>
            </a>
            <a href="https://www.instagram.com/assur.af/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" title="Instagram">
              <i class="fab fa-instagram"></i>
            </a>
            <a href="https://www.youtube.com/channel/UCqAcE6_oY7sHHHpGZ_b00Kg/" target="_blank" rel="noopener noreferrer" aria-label="YouTube" title="YouTube">
              <i class="fab fa-youtube"></i>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="nf__bottom">
      <div class="nf__bottom-inner">
        <p>© {{ year }} Assuraf — Tous droits réservés.</p>
        <div class="nf__legal">
          <router-link to="/info/legale">{{ $t('footer.assuraf_content_list[2]') }}</router-link>
          <router-link to="/condition/generale">{{ $t('footer.assuraf_content_list[3]') }}</router-link>
        </div>
      </div>
    </div>

    <login-form :visible="showLoginForm" @close="showLoginForm = false"></login-form>
    <CookiePopup v-if="showCookiePopup" @accepted="handleCookieAccept" @later="handleCookieLater" />
  </footer>
</template>

<script>
import PushInDataLayer from '../services/TagManager';
import CookiePopup from './auth/CookiePopup.vue';

export default {
  name: 'NewFooter',
  components: {
    LoginForm: () => import(/* webpackPrefetch: true */ './auth/Login'),
    CookiePopup
  },
  data: () => ({
    year: new Date().getFullYear(),
    showLoginForm: false,
    showCookiePopup: false
  }),
  methods: {
    goToSinistre() {
      if (this.$store.state.isUserLoggedIn) {
        this.$router.push('/sinistre');
      } else {
        this.showLoginForm = true;
      }
    },
    RedirectionEspaceAssure() {
      if (this.$store.state.isUserLoggedIn) {
        this.$router.push('/dashboard');
      } else {
        this.showLoginForm = true;
      }
    },
    handleCookieAccept() {
      this.showCookiePopup = false;
      localStorage.setItem('cookieConsent', 'accepted');
      const GtmVal = { event: 'cookie_consent_accepted' };
      PushInDataLayer(GtmVal);
    },
    handleCookieLater() {
      this.showCookiePopup = false;
      const laterTime = new Date().getTime() + 24 * 60 * 60 * 1000;
      localStorage.setItem('cookieLaterTime', String(laterTime));
      const GtmVal = { event: 'cookie_consent_later' };
      PushInDataLayer(GtmVal);
    },
    checkCookieConsent() {
      const consent = localStorage.getItem('cookieConsent');
      const laterTime = localStorage.getItem('cookieLaterTime');
      const currentTime = new Date().getTime();
      if (consent === 'accepted') {
        this.showCookiePopup = false;
      } else if (laterTime && currentTime < parseInt(laterTime, 10)) {
        this.showCookiePopup = false;
      } else {
        this.showCookiePopup = true;
      }
    }
  },
  mounted() {
    this.checkCookieConsent();
  }
};
</script>

<style lang="less" scoped>
.nf {
  --c-orange: #ffa409;
  --c-blue: #5B94BC;
  --c-ink: #23262b;

  position: relative;
  background: linear-gradient(180deg, #2b2f35 0%, var(--c-ink) 100%);
  color: rgba(255, 255, 255, 0.88);

  &__accent {
    height: 4px;
    background: linear-gradient(90deg, #ffa409 0%, #f57c00 40%, #5B94BC 100%);
  }

  &__container {
    max-width: 1240px;
    margin: 0 auto;
    padding: 64px 32px 48px;
  }

  &__grid {
    display: grid;
    grid-template-columns: 1.3fr 1fr 1.2fr 1.1fr;
    gap: 40px;
  }

  &__col--brand {
    max-width: 320px;
  }

  &__logo {
    display: inline-block;
    margin-bottom: 18px;

    img {
      height: 52px;
      width: auto;
      object-fit: contain;
    }
  }

  &__tagline {
    margin: 0 0 22px;
    font-size: 14px;
    line-height: 1.7;
    color: rgba(255, 255, 255, 0.6);
  }

  &__contact {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;

    li {
      display: flex;
      align-items: flex-start;
      gap: 12px;
      font-size: 14px;
      line-height: 1.5;

      i {
        margin-top: 2px;
        color: #ffa409;
        width: 16px;
        text-align: center;
      }

      a {
        color: rgba(255, 255, 255, 0.88);
        text-decoration: none;
        transition: color 0.2s ease;

        &:hover {
          color: #ffa409;
        }
      }
    }
  }

  &__title {
    margin: 0 0 18px;
    font-size: 15px;
    font-weight: 800;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    color: #fff;

    &--social {
      margin-top: 32px;
    }
  }

  &__links {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;

    li {
      font-size: 14px;
    }

    a {
      color: rgba(255, 255, 255, 0.78);
      text-decoration: none;
      transition: color 0.2s ease;

      &:hover {
        color: #ffa409;
      }
    }

    .nf__sep {
      margin-top: 6px;
      padding-top: 12px;
      border-top: 1px solid rgba(255, 255, 255, 0.14);
      color: #ffa409;
      font-weight: 700;
      font-size: 13px;
      letter-spacing: 1px;
      text-transform: uppercase;
    }
  }

  &__stores {
    display: flex;
    flex-direction: column;
    gap: 12px;

    img {
      height: 44px;
      width: auto;
      border-radius: 10px;
    }
  }

  &__social {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    a {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 38px;
      height: 38px;
      border-radius: 12px;
      background: rgba(255, 255, 255, 0.1);
      color: #fff;
      text-decoration: none;
      font-size: 15px;
      transition: background 0.2s ease, transform 0.2s ease, color 0.2s ease;

      &:hover {
        background: #ffa409;
        color: #23262b;
        transform: translateY(-3px);
      }
    }
  }

  &__bottom {
    border-top: 1px solid rgba(255, 255, 255, 0.12);

    &-inner {
      max-width: 1240px;
      margin: 0 auto;
      padding: 22px 32px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      flex-wrap: wrap;

      p {
        margin: 0;
        font-size: 13px;
        color: rgba(255, 255, 255, 0.55);
      }
    }
  }

  &__legal {
    display: flex;
    gap: 20px;

    a {
      font-size: 13px;
      color: rgba(255, 255, 255, 0.55);
      text-decoration: none;

      &:hover {
        color: #ffa409;
      }
    }
  }
}

@media (max-width: 991px) {
  .nf {
    &__grid {
      grid-template-columns: 1fr 1fr;
      gap: 32px;
    }
  }
}

@media (max-width: 600px) {
  .nf {
    &__container {
      padding: 48px 22px 36px;
    }

    &__grid {
      grid-template-columns: 1fr;
      gap: 30px;
    }

    &__bottom-inner {
      padding: 18px 22px;
      justify-content: center;
      text-align: center;
    }
  }
}
</style>
